import axiosInstance from '../../axios/instance'

/**
 * Retrieves client applications or accounts based on the provided parameters.
 *
 * @param {string} email - Email of the client or account.
 * @returns {Promise<Object>} - Object with application or account data.
 * @throws {Error} - If an error occurs during the request or the token is missing.
 */
async function isEmailFree(email) {
    try {
        const response = await axiosInstance.get(`/api/client-applications/email?email=${email}`)
        return response.status === 204
    } catch (error) {
        console.error('Error fetching client applications or accounts data:', error)
        throw error
    }
}

export default isEmailFree
